// Case-study lightbox: screenshots, gallery images and diagrams.
//
// - <a class="lightbox" href="full-size.png"> opens that image. Without JS the
//   link simply opens the full-size image.
// - Diagrams (.cs-diagram .diagram-scroll) open a copy of their inline SVG;
//   an "Enlarge diagram" button before each one gives keyboard access.
//
// Everything opens as large as the screen allows in a native <dialog> (focus
// handling, Escape to close and scroll locking come for free). Clicking the
// image/diagram toggles a larger, scrollable view (full resolution for images,
// 2x for diagrams); clicking anywhere off it, the × button, or Escape closes it.
(function () {
	const links = document.querySelectorAll('a.lightbox');
	const diagrams = document.querySelectorAll('.cs-diagram .diagram-scroll');
	if ((!links.length && !diagrams.length) || typeof HTMLDialogElement === 'undefined') {
		return;
	}

	const dialog = document.createElement('dialog');
	dialog.className = 'lightbox-dialog';
	dialog.innerHTML = '<button type="button" class="lightbox-close" aria-label="Close">×</button><div class="lightbox-content"></div>';
	document.body.appendChild(dialog);

	const content = dialog.querySelector('.lightbox-content');
	let opener = null;

	const open = (node, trigger) => {
		opener = trigger;
		content.replaceChildren(node);
		dialog.showModal();
	};

	links.forEach(link => {
		link.addEventListener('click', event => {
			event.preventDefault();
			const img = document.createElement('img');
			img.src = link.href;
			const source = link.querySelector('img');
			img.alt = source ? source.alt : '';
			open(img, link);
		});
	});

	diagrams.forEach(wrap => {
		const svg = wrap.querySelector('svg');
		if (!svg) {
			return;
		}
		const title = svg.querySelector('title');
		wrap.classList.add('lightbox-diagram');

		// A real button for keyboard and screen-reader users, shown on focus.
		// The wrapper stays a plain mouse target so the SVG keeps its own
		// title and description.
		const button = document.createElement('button');
		button.type = 'button';
		button.className = 'diagram-enlarge';
		button.textContent = 'Enlarge diagram';
		if (title) {
			const name = document.createElement('span');
			name.className = 'sr-only';
			name.textContent = ': ' + title.textContent;
			button.appendChild(name);
		}
		wrap.before(button);

		const show = trigger => {
			const copy = svg.cloneNode(true);
			// Show the finished diagram, not a mid-animation frame.
			copy.classList.remove('pop-ready');
			copy.classList.add('popped');
			open(copy, trigger);
		};
		wrap.addEventListener('click', () => show(null));
		button.addEventListener('click', () => show(button));
	});

	// Clicks on the image/diagram toggle the larger view; anything else closes.
	dialog.addEventListener('click', event => {
		if (content.firstElementChild && content.firstElementChild.contains(event.target)) {
			dialog.classList.toggle('zoomed');
		} else {
			dialog.close();
		}
	});

	dialog.addEventListener('close', () => {
		dialog.classList.remove('zoomed');
		content.replaceChildren();
		if (opener) {
			opener.focus();
		}
	});
})();
